export class BarcodeRequest{
    barcode:string;
    unitId:number;
    itemId?:number;
    constructor(barcode:string,unitId:number,itemId?:number){
        this.barcode = barcode
        this.unitId = unitId
        this.itemId = itemId
    }
}